import PaymentTermEvent from "@/domains/PaymentTerms/PaymentTermEvent";
import Dictionary from "@/core/types/Dictionary";

class PaymentTermsService {

    /**
     * Кеш событий условий оплаты. Наполняется из Dictionaries общим эндпоинтом.
     * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
     */
    static paymentTermEvents = reactive(new Dictionary<string, PaymentTermEvent>());

    /** Список событий условий оплаты */
    static getEventList(): PaymentTermEvent[] {
        return this.paymentTermEvents.toArray();
    }

    /** Получает событие по id */
    static getEventById(id: string): PaymentTermEvent | undefined {
        return this.paymentTermEvents.get(id);
    }

    /** Фильтрует события по типу оплаты */
    static getEventsByPaymentType(paymentType: 'pre' | 'post'): PaymentTermEvent[] {
        return this.paymentTermEvents.filter(event => event.paymentType === paymentType);
    }
}

export default PaymentTermsService;